<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'HelloWorld'
}
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue